<template>
<div id="msgTips" class="hide min_tips_box middle" :class="{show:show}">
		<b class="bg"></b> <span class="tips_content">{{message}}</span>
</div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      show: false
    }
  }
}
</script>

<style scoped>
.hide{
	display:none;
}
.show{
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/plugins/ToastMessage/index.vue